<div class="info-banner">
  <div>
    <span class="info-icon"><i class="fas fa-info-circle"></i></span>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
